import { render } from "./AppRenameFolder.vue?vue&type=template&id=066a50e2&scoped=true&ts=true"
import script from "./AppRenameFolder.vue?vue&type=script&lang=ts"
export * from "./AppRenameFolder.vue?vue&type=script&lang=ts"

import "./AppRenameFolder.vue?vue&type=style&index=0&id=066a50e2&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066a50e2"]])

export default __exports__